var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "98e4b9ebad13700d13a48f4e0369d2f99f7d3a76"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["nc_accthome@enova"] = {
  id: "98e4b9ebad13700d13a48f4e0369d2f99f7d3a76"
};